import React from 'react';
import { Button } from '@/components/atoms';
import { getFormattedDate } from '@/utils/commons';
import './reviewActionHeader.scss';
import { ROUTES } from '@/utils/constants/routesConstants';

/**
 * ReviewActionHeader
 * Header bar for review screens, similar to the UI in the attached image. Shows a completed date, action buttons, and supports dark mode.
 * @param {Object} props
 * @param {string} props.completedDate - Date string for completed status
 * @param {function} props.onDuplicate - Handler for Duplicate Sales Target
 * @param {function} props.onDownload - Handler for Download
 */
const ReviewActionHeader = ({ completedDate, onDuplicate, onDownload, isDuplicateEnabled = false }) => {
  return (
    <div className="review-action-header__container">

      {completedDate != "" ? <span className="review-action-header__completed">Completed {getFormattedDate(completedDate, false, '-', 'yyyy-mm-dd')}</span> : <span className="review-action-header__completed"> </span>}

      <div className="review-action-header__actions">
        {isDuplicateEnabled && <Button
          handleButton={() => onDuplicate(ROUTES.SALES_TARGET_ADD)}
          uiSchema={{
            className: 'ml-4',
            title: 'Duplicate Sales Target',
            variant: 'secondary',
            size: 'small',
          }}
        />}
        <Button
          handleButton={onDownload}
          uiSchema={{
            className: 'ml-4',
            title: 'Download',
            variant: 'primary',
            size: 'small',
            disabled: !isDuplicateEnabled,
          }}
        />
      </div>
    </div>
  );
};

export default ReviewActionHeader;
